// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{margin:0;padding:0;width:100vw;max-width:100vw;height:100vh;max-height:100vh}", ""]);
// Exports
module.exports = exports;
